export default __webpack_public_path__ + "scripts/resource/601ca89d0b640c84d11799b10ac12b30.svg";